import React, { useEffect, useState, useRef } from "react";
import { ArrowForward, Close, FilterList, Download } from "@mui/icons-material";
import TableComponent3PL from "./component/TableComponent3PL";
import { httpclient } from "../../../../utils/httpClient";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  styled,
  TextField,
} from "@mui/material";

const columns = [
  { id: "customerName", name: "Customer Name" },
  { id: "netsuiteOrderNumber", name: "Netsuite Order Number" },
  { id: "originalOrderNumber", name: "Org Cust PO Number" },
  { id: "poNumber", name: "PO Number" },
  { id: "orderCreated", name: "Customer Order Created" },
  { id: "assignBranch", name: "Assigned to Branch" },
  { id: "despatchGeneratedDate", name: "Despatch Generated Date" },
  { id: "readyDate", name: "Ready" },
  { id: "allocateDate", name: "Allocated" },
  { id: "pickingDate", name: "Picking" },
  { id: "closedDate", name: "Closed" },
  { id: "manifestCallDate", name: "Manifest call Date" },
  { id: "custMustShipByDate", name: "Cust Must Ship By Date" },
  { id: "orderStatus", name: "Status" },
  { id: "shipComplete", name: "Ship Complete" },
];

console.log("columns", columns);

//added new column
const FilteredBox = styled(Box)(({ theme }) => ({
  background: "#f9f9f9",
  padding: "5px 10px",
  borderRadius: "5px",
  "& p": {
    margin: "0",
    marginRight: "10px",
    display: "inline-block",
    background: "#dedede",
    borderRadius: "10px",
    padding: "2px 5px",
  },
  "& svg": {
    fontSize: "15px",
    cursor: "pointer",
    position: "relative",
    top: "3px",
    background: theme.palette.primary.dark,
    color: "#fff",
    borderRadius: "50%",
    padding: "2px",
    marginLeft: "2px",
  },
}));

const Header = styled("div")(({ theme }) => ({
  "& h1": {
    color: theme.palette.primary.dark,
    margin: "0",
  },
}));

const configRowPerPage = JSON.parse(localStorage.getItem("configRowPerPage")) || 20;

const OrdersReports3PL = () => {
  const buttonRef = useRef(null);
  const [exportRows, setExportRows] = useState("");
  const [loadingExport, setLoadingExport] = useState(false);


  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [to, setTo] = useState(configRowPerPage);
  const [rowsPerPage, setRowsPerPage] = useState(configRowPerPage);
  const [total, setTotal] = useState(0);
  const [filterOpen, setFilterOpen] = useState(false);

  const [dropdownOptions, setDropdownOptions] = useState({
    branchList: [],
    orderStatus: [],
    customerNameList: [],
  });

  const [filterData, setFilterData] = useState({
    poNumber: "",
    netsuiteOrderNumber: "",
    customerName: "",
    customerID: "",
    assignBranch: "",
    assignBranchID: "",
    orderStatus: "",
    orderStatusID: "",
    orderCreatedStart: "",
    orderCreatedEnd: "",
    dispatchGeneratedStartDate: "",
    dispatchGeneratedEndDate: "",
    manifestCallStartDate: "",
    manifestCallEndDate: "",
    custMustShipByStartDate: "",
    custMustShipByEndDate: "",
    closedStartDate: "",
    closedEndDate: "",
    shipmentCompleted: "",
    isThreePLIssueOrder: "", // NEW FILTER ADDED HERE
    remove: false,
  });

  const [submittedData, setSubmittedData] = useState({
    poNumber: "",
    netsuiteOrderNumber: "",
    customerName: "",
    customerID: "",
    assignBranch: "",
    assignBranchID: "",
    orderStatus: "",
    orderStatusID: "",
    orderCreatedStart: "",
    orderCreatedEnd: "",
    dispatchGeneratedStartDate: "",
    dispatchGeneratedEndDate: "",
    manifestCallStartDate: "",
    manifestCallEndDate: "",
    custMustShipByStartDate: "",
    custMustShipByEndDate: "",
    closedStartDate: "",
    closedEndDate: "",
    shipmentCompleted: "",
    isThreePLIssueOrder: "", // NEW FILTER ADDED HERE
    submit: false,
  });

  // Load initial data + filters from localStorage
  useEffect(() => {
    const savedFilter = JSON.parse(localStorage.getItem("current_3pl_orders_filter"));
    if (savedFilter) {
      setFilterData(savedFilter);
      const hasActiveFilters =
        savedFilter.poNumber ||
        savedFilter.netsuiteOrderNumber ||
        savedFilter.customerID ||
        savedFilter.assignBranchID ||
        savedFilter.orderStatusID ||
        savedFilter.orderCreatedStart ||
        savedFilter.orderCreatedEnd ||
        savedFilter.dispatchGeneratedStartDate ||
        savedFilter.dispatchGeneratedEndDate ||
        savedFilter.manifestCallStartDate ||
        savedFilter.manifestCallEndDate ||
        savedFilter.custMustShipByStartDate ||
        savedFilter.custMustShipByEndDate ||
        savedFilter.closedStartDate ||
        savedFilter.closedEndDate ||
        savedFilter.shipmentCompleted ||
        savedFilter.isThreePLIssueOrder; // CHECK ADDED HERE

      if (hasActiveFilters) {
        setSubmittedData({ ...savedFilter, submit: true });
        fetchFilteredData(savedFilter, 1);
      } else {
        getOrdersReports();
      }
    } else {
      getOrdersReports();
    }
  }, []);

  useEffect(() => {
    const trimmed = { ...filterData };
    Object.keys(trimmed).forEach((key) => {
      if (typeof trimmed[key] === "string") trimmed[key] = trimmed[key].trim();
    });
    setFilterData(trimmed);

    if (filterData.remove) {
      handleFilter();
    }

    const isEmpty =
      !trimmed.poNumber &&
      !trimmed.netsuiteOrderNumber &&
      !trimmed.customerID &&
      !trimmed.assignBranchID &&
      !trimmed.orderStatusID &&
      !trimmed.orderCreatedStart &&
      !trimmed.orderCreatedEnd &&
      !trimmed.dispatchGeneratedStartDate &&
      !trimmed.dispatchGeneratedEndDate &&
      !trimmed.manifestCallStartDate &&
      !trimmed.manifestCallEndDate &&
      !trimmed.custMustShipByStartDate &&
      !trimmed.custMustShipByEndDate &&
      !trimmed.closedStartDate && 
      !trimmed.closedEndDate &&
      !trimmed.shipmentCompleted &&
      !trimmed.isThreePLIssueOrder; // CHECK ADDED HERE

    if (isEmpty) {
      setSubmittedData((prev) => ({ ...prev, submit: false }));
    }
  }, [filterData]);

  const getOrdersReports = () => {
    setLoading(true);
    httpclient
      .get(`3pl/orders-status-report?page=${page}&per_page=${rowsPerPage}`)
      .then(({ data }) => {
        if (data.success) {
          setRows(data.data);
          setTotal(data.meta.total);
          setRowsPerPage(parseInt(data.meta.per_page));
          setPage(data.meta.current_page);
          setFrom(data.meta.from);
          setTo(data.meta.to);
          setDropdownOptions({
            branchList: data.branchList || [],
            orderStatus: data.orderStatus || [],
            customerNameList: data.customerNameList || [],
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.clear();
          window.location = "/login";
        }
        setLoading(false);
      });
  };

  const fetchFilteredData = (filters, targetPage = page) => {
    setLoading(true);
    const queryString = new URLSearchParams({
      poNumber: filters.poNumber || "",
      netsuiteOrderNumber: filters.netsuiteOrderNumber || "",
      customerName: filters.customerID || "",
      assignBranch: filters.assignBranchID || "",
      orderStatus: filters.orderStatusID || "",
      orderCreatedStart: filters.orderCreatedStart || "",
      orderCreatedEnd: filters.orderCreatedEnd || "",
      dispatchGeneratedStartDate: filters.dispatchGeneratedStartDate || "",
      dispatchGeneratedEndDate: filters.dispatchGeneratedEndDate || "",
      manifestCallStartDate: filters.manifestCallStartDate || "",
      manifestCallEndDate: filters.manifestCallEndDate || "",
      custMustShipByStartDate: filters.custMustShipByStartDate || "",
      custMustShipByEndDate: filters.custMustShipByEndDate || "",
      closedStartDate: filters.closedStartDate || "",
      closedEndDate: filters.closedEndDate || "",
      shipmentCompleted: filters.shipmentCompleted || "",
      isThreePLIssueOrder: filters.isThreePLIssueOrder || "", // NEW PARAMETER ADDED HERE
      page: targetPage,
      per_page: rowsPerPage,
    }).toString();

    httpclient
      .get(`3pl/orders-status-report?${queryString}`)
      .then(({ data }) => {
        if (data.success) {
          setRows(data.data);
          setTotal(data.meta.total);
          setRowsPerPage(parseInt(data.meta.per_page));
          setPage(data.meta.current_page);
          setFrom(data.meta.from);
          setTo(data.meta.to);
          setDropdownOptions({
            branchList: data.branchList || [],
            orderStatus: data.orderStatus || [],
            customerNameList: data.customerNameList || [],
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.clear();
          window.location = "/login";
        }
        setLoading(false);
      });
  };

  // --- NEW EXPORT FUNCTION ---
  const handleExport = () => {
    setLoadingExport(true);
    setExportRows("");

    const queryString = new URLSearchParams({
      poNumber: filterData.poNumber || "",
      netsuiteOrderNumber: filterData.netsuiteOrderNumber || "",
      customerName: filterData.customerID || "",
      assignBranch: filterData.assignBranchID || "",
      orderStatus: filterData.orderStatusID || "",
      orderCreatedStart: filterData.orderCreatedStart || "",
      orderCreatedEnd: filterData.orderCreatedEnd || "",
      dispatchGeneratedStartDate: filterData.dispatchGeneratedStartDate || "",
      dispatchGeneratedEndDate: filterData.dispatchGeneratedEndDate || "",
      manifestCallStartDate: filterData.manifestCallStartDate || "",
      manifestCallEndDate: filterData.manifestCallEndDate || "",
      custMustShipByStartDate: filterData.custMustShipByStartDate || "",
      custMustShipByEndDate: filterData.custMustShipByEndDate || "",
      closedStartDate: filterData.closedStartDate || "",
      closedEndDate: filterData.closedEndDate || "",
      shipmentCompleted: filterData.shipmentCompleted || "",
      isThreePLIssueOrder: filterData.isThreePLIssueOrder || "", // NEW PARAMETER ADDED HERE
    }).toString();

    httpclient
      .get(`3pl/orders-status-report-export?${queryString}`)
      .then((response) => {
        console.log(response.data)
        const getFormattedDateTime = () => {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, '0');
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const year = now.getFullYear();
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          return `${day}${month}${year}${hours}${minutes}${seconds}`;
        };

        const formattedDateTime = getFormattedDateTime();
        const fileName = `3PL_ORDER_REPORT_${formattedDateTime}.csv`;

        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setExportRows(url);
        setTimeout(() => {
          setExportRows("");
        }, 2000);

        setLoadingExport(false);
      })
      .catch((error) => {
        console.error("Error downloading file: ", error);
        setLoadingExport(false);
      });
  };

  const handleFilter = () => {
    const newSubmitted = {
      poNumber: filterData.poNumber,
      netsuiteOrderNumber: filterData.netsuiteOrderNumber,
      customerName: filterData.customerName,
      customerID: filterData.customerID,
      assignBranch: filterData.assignBranch,
      assignBranchID: filterData.assignBranchID,
      orderStatus: filterData.orderStatus,
      orderStatusID: filterData.orderStatusID,
      orderCreatedStart: filterData.orderCreatedStart,
      orderCreatedEnd: filterData.orderCreatedEnd,
      dispatchGeneratedStartDate: filterData.dispatchGeneratedStartDate,
      dispatchGeneratedEndDate: filterData.dispatchGeneratedEndDate,
      manifestCallStartDate: filterData.manifestCallStartDate,
      manifestCallEndDate: filterData.manifestCallEndDate,
      custMustShipByStartDate: filterData.custMustShipByStartDate,
      custMustShipByEndDate: filterData.custMustShipByEndDate,
      closedStartDate: filterData.closedStartDate,
      closedEndDate: filterData.closedEndDate,
      shipmentCompleted: filterData.shipmentCompleted,
      isThreePLIssueOrder: filterData.isThreePLIssueOrder, // NEW FIELD ADDED HERE
      submit: true,
    };
    setSubmittedData(newSubmitted);
    setFilterData((prev) => ({ ...prev, remove: false }));
    localStorage.setItem("current_3pl_orders_filter", JSON.stringify(filterData));
    fetchFilteredData(filterData, 1);
  };

  const handleRemove = (key) => {
    const resetFields = {
      customerID: { customerID: "", customerName: "" },
      assignBranchID: { assignBranchID: "", assignBranch: "" },
      orderStatusID: { orderStatusID: "", orderStatus: "" },
    };

    setFilterData((prev) => ({
      ...prev,
      ...(resetFields[key] || { [key]: "" }),
      remove: true,
    }));

    setSubmittedData((prev) => ({
      ...prev,
      ...(resetFields[key] || { [key]: "" }),
    }));
  };

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value, remove: false }));
  };

  // Autocomplete handlers
  const handleCustomerChange = (value) => {
    setFilterData((prev) => ({
      ...prev,
      customerID: value ? value.id : "",
      customerName: value ? value.name : "",
      remove: false,
    }));
  };

  const handleBranchChange = (value) => {
    setFilterData((prev) => ({
      ...prev,
      assignBranchID: value ? value.branchID : "",
      assignBranch: value ? value.branchName : "",
      remove: false,
    }));
  };

  const handleOrderStatusChange = (value) => {
    setFilterData((prev) => ({
      ...prev,
      orderStatusID: value ? value.id : "",
      orderStatus: value ? value.name : "",
      remove: false,
    }));
  };

  const handleChangePage = (e, newPage) => {
    setLoading(true);
    const targetPage = newPage + 1;
    if (submittedData.submit) {
      fetchFilteredData(filterData, targetPage);
    } else {
      httpclient
        .get(`3pl/orders-status-report?page=${targetPage}&per_page=${rowsPerPage}`)
        .then(({ data }) => {
          if (data.success) {
            setRows(data.data);
            setTotal(data.meta.total);
            setRowsPerPage(parseInt(data.meta.per_page));
            setPage(data.meta.current_page);
            setFrom(data.meta.from);
            setTo(data.meta.to);
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            localStorage.clear();
            window.location = "/login";
          }
          setLoading(false);
        });
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    localStorage.setItem("configRowPerPage", newRowsPerPage);
    setLoading(true);
    if (submittedData.submit) {
      fetchFilteredData(filterData, 1);
    } else {
      httpclient
        .get(`3pl/orders-status-report?page=1&per_page=${newRowsPerPage}`)
        .then(({ data }) => {
          if (data.success) {
            setRows(data.data);
            setTotal(data.meta.total);
            setRowsPerPage(parseInt(data.meta.per_page));
            setPage(data.meta.current_page);
            setFrom(data.meta.from);
            setTo(data.meta.to);
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            localStorage.clear();
            window.location = "/login";
          }
          setLoading(false);
        });
    }
  };

  const hadleFilterOpen = () => {
    setFilterOpen((prev) => !prev);
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <Header>
            <h1>3PL Orders Reports</h1>
          </Header>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          {exportRows !== "" ? (
            <Button
              download
              href={exportRows}
              color="primary"
              variant="contained"
              style={{ marginRight: "10px" }}
              ref={buttonRef}
            >
              Export <Download style={{ marginLeft: "5px" }} fontSize="small" />
            </Button>
          ) : (exportRows === "" && loadingExport) ? (
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: "10px" }}
            >
              {"Generating Data to Export..."}
            </Button>
          ) : (
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: "10px" }}
              disabled={!submittedData.submit}
              onClick={handleExport}
            >
              {"Export"}{<Download style={{ marginLeft: "5px" }} fontSize="small" />}
            </Button>
          )}

          <Button color="primary" variant="contained" onClick={hadleFilterOpen}>
            Filter <FilterList style={{ marginLeft: "5px" }} fontSize="small" />
          </Button>
        </Grid>

        {/* Filter Panel */}
        <Grid item xs={12}>
          <Collapse in={filterOpen}>
            <Card>
              <Box p={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <InputLabel>PO Number</InputLabel>
                    <TextField
                      variant="outlined"
                      name="poNumber"
                      value={filterData.poNumber}
                      onChange={handleChangeFilter}
                      onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Netsuite Order Number</InputLabel>
                    <TextField
                      variant="outlined"
                      name="netsuiteOrderNumber"
                      value={filterData.netsuiteOrderNumber}
                      onChange={handleChangeFilter}
                      onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Customer Name</InputLabel>
                    <Autocomplete
                      clearable
                      disablePortal
                      options={dropdownOptions.customerNameList}
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      value={
                        dropdownOptions.customerNameList.find((opt) => opt.id === filterData.customerID) || null
                      }
                      onChange={(e, newValue) => handleCustomerChange(newValue)}
                      renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Assigned to Branch</InputLabel>
                    <Autocomplete
                      clearable
                      disablePortal
                      options={dropdownOptions.branchList}
                      getOptionLabel={(option) => option?.branchName || ""}
                      isOptionEqualToValue={(option, value) => option?.branchID === value?.branchID}
                      value={
                        dropdownOptions.branchList.find((opt) => opt.branchID === filterData.assignBranchID) || null
                      }
                      onChange={(e, newValue) => handleBranchChange(newValue)}
                      renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Order Status</InputLabel>
                    <Autocomplete
                      clearable
                      disablePortal
                      options={dropdownOptions.orderStatus}
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      value={
                        dropdownOptions.orderStatus.find((opt) => opt.id === filterData.orderStatusID) || null
                      }
                      onChange={(e, newValue) => handleOrderStatusChange(newValue)}
                      renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Shipment Completed</InputLabel>
                    <FormControl fullWidth>
                      <Select
                        value={filterData.shipmentCompleted}
                        name="shipmentCompleted"
                        onChange={handleChangeFilter}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                        <MenuItem value="0">No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  
                  {/* --- NEW FILTER INPUT START --- */}
                  <Grid item xs={12} md={4}>
                    <InputLabel>Issue Order</InputLabel>
                    <FormControl fullWidth>
                      <Select
                        value={filterData.isThreePLIssueOrder}
                        name="isThreePLIssueOrder"
                        onChange={handleChangeFilter}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                        <MenuItem value="0">No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* --- NEW FILTER INPUT END --- */}

                  {/* Date Range Filters */}
                  <Grid item xs={12} md={4}>
                    <InputLabel>Order Created Start Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="orderCreatedStart"
                      type="date"
                      value={filterData.orderCreatedStart}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Order Created End Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="orderCreatedEnd"
                      type="date"
                      value={filterData.orderCreatedEnd}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Dispatch Generated Start Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="dispatchGeneratedStartDate"
                      type="date"
                      value={filterData.dispatchGeneratedStartDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Dispatch Generated End Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="dispatchGeneratedEndDate"
                      type="date"
                      value={filterData.dispatchGeneratedEndDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Manifest Call Start Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="manifestCallStartDate"
                      type="date"
                      value={filterData.manifestCallStartDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Manifest Call End Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="manifestCallEndDate"
                      type="date"
                      value={filterData.manifestCallEndDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <InputLabel>Cust Must Ship By Start Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="custMustShipByStartDate"
                      type="date"
                      value={filterData.custMustShipByStartDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Cust Must Ship By End Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="custMustShipByEndDate"
                      type="date"
                      value={filterData.custMustShipByEndDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Warehouse Closed Start Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="closedStartDate"
                      type="date"
                      value={filterData.closedStartDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Warehouse Closed End Date</InputLabel>
                    <TextField
                      variant="outlined"
                      name="closedEndDate"
                      type="date"
                      value={filterData.closedEndDate}
                      onChange={handleChangeFilter}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box textAlign="right">
                      <Button variant="contained" color="primary" onClick={handleFilter}>
                        Filter <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Collapse>
        </Grid>

        {/* Applied Filters */}
        {(submittedData.poNumber ||
          submittedData.netsuiteOrderNumber ||
          submittedData.customerID ||
          submittedData.assignBranchID ||
          submittedData.orderStatusID ||
          submittedData.orderCreatedStart ||
          submittedData.orderCreatedEnd ||
          submittedData.dispatchGeneratedStartDate ||
          submittedData.dispatchGeneratedEndDate ||
          submittedData.manifestCallStartDate ||
          submittedData.manifestCallEndDate ||
          submittedData.custMustShipByStartDate ||
          submittedData.custMustShipByEndDate ||
          submittedData.closedStartDate ||
          submittedData.closedEndDate ||
          submittedData.shipmentCompleted ||
          submittedData.isThreePLIssueOrder) && ( // CHECK ADDED HERE
          <Grid item xs={12}>
            <FilteredBox>
              <span>Filtered: </span>
              {submittedData.poNumber && (
                <p>
                  <span>PO Number: {submittedData.poNumber}</span>
                  <Close fontSize="small" onClick={() => handleRemove("poNumber")} />
                </p>
              )}
              {submittedData.netsuiteOrderNumber && (
                <p>
                  <span>Netsuite Order Number: {submittedData.netsuiteOrderNumber}</span>
                  <Close fontSize="small" onClick={() => handleRemove("netsuiteOrderNumber")} />
                </p>
              )}
              {submittedData.customerID && (
                <p>
                  <span>Customer Name: {submittedData.customerName}</span>
                  <Close fontSize="small" onClick={() => handleRemove("customerID")} />
                </p>
              )}
              {submittedData.assignBranchID && (
                <p>
                  <span>Assigned to Branch: {submittedData.assignBranch}</span>
                  <Close fontSize="small" onClick={() => handleRemove("assignBranchID")} />
                </p>
              )}
              {submittedData.orderStatusID && (
                <p>
                  <span>Order Status: {submittedData.orderStatus}</span>
                  <Close fontSize="small" onClick={() => handleRemove("orderStatusID")} />
                </p>
              )}
              {submittedData.shipmentCompleted && (
                <p>
                  <span>Shipment Completed: {submittedData.shipmentCompleted === "1" ? "Yes" : "No"}</span>
                  <Close fontSize="small" onClick={() => handleRemove("shipmentCompleted")} />
                </p>
              )}
              
              {/* --- NEW ACTIVE FILTER TAG --- */}
              {submittedData.isThreePLIssueOrder && (
                <p>
                  <span>Issue Order: {submittedData.isThreePLIssueOrder === "1" ? "Yes" : "No"}</span>
                  <Close fontSize="small" onClick={() => handleRemove("isThreePLIssueOrder")} />
                </p>
              )}
              {/* ------------------------------ */}

              {submittedData.orderCreatedStart && (
                <p>
                  <span>Order Created Start: {submittedData.orderCreatedStart}</span>
                  <Close fontSize="small" onClick={() => handleRemove("orderCreatedStart")} />
                </p>
              )}
              {submittedData.orderCreatedEnd && (
                <p>
                  <span>Order Created End: {submittedData.orderCreatedEnd}</span>
                  <Close fontSize="small" onClick={() => handleRemove("orderCreatedEnd")} />
                </p>
              )}
              {submittedData.dispatchGeneratedStartDate && (
                <p>
                  <span>Dispatch Generated Start: {submittedData.dispatchGeneratedStartDate}</span>
                  <Close fontSize="small" onClick={() => handleRemove("dispatchGeneratedStartDate")} />
                </p>
              )}
              {submittedData.dispatchGeneratedEndDate && (
                <p>
                  <span>Dispatch Generated End: {submittedData.dispatchGeneratedEndDate}</span>
                  <Close fontSize="small" onClick={() => handleRemove("dispatchGeneratedEndDate")} />
                </p>
              )}
              {submittedData.manifestCallStartDate && (
                <p>
                  <span>Manifest Call Start: {submittedData.manifestCallStartDate}</span>
                  <Close fontSize="small" onClick={() => handleRemove("manifestCallStartDate")} />
                </p>
              )}
              {submittedData.manifestCallEndDate && (
                <p>
                  <span>Manifest Call End: {submittedData.manifestCallEndDate}</span>
                  <Close fontSize="small" onClick={() => handleRemove("manifestCallEndDate")} />
                </p>
              )}
              {(submittedData.custMustShipByStartDate || submittedData.custMustShipByEndDate) && (
                <p>
                  <span>Cust Must Ship By: {submittedData.custMustShipByStartDate} - {submittedData.custMustShipByEndDate}</span>
                  <Close fontSize="small" onClick={() => {handleRemove("custMustShipByStartDate"); handleRemove("custMustShipByEndDate")}} />
                </p>
              )}
              {(submittedData.closedStartDate || submittedData.closedEndDate) && (
                <p>
                  <span>Closed: {submittedData.closedStartDate} - {submittedData.closedEndDate}</span>
                  <Close fontSize="small" onClick={() => {handleRemove("closedStartDate"); handleRemove("closedEndDate")}} />
                </p>
              )}
            </FilteredBox>
          </Grid>
        )}

        {/* Table */}
        <Grid item xs={12}>
          <TableComponent3PL
            columns={columns}
            rows={rows}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
            from={from}
            to={to}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default OrdersReports3PL;